/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Тип услуги для грузоместа
 */
export type OrderCargoTotalServiceType = {
  /**
   * Тип услуги
   */
  id: OrderCargoTotalServiceType.Id
  /**
   * Название типа услуги
   */
  name: string
}
export namespace OrderCargoTotalServiceType {
  /**
   * Тип услуги
   */
  export enum Id {
    CUSTOM = 'custom'
  }
}
